// External Dependencies
import styled from '@emotion/styled';

// Component Definition
const PortfolioItemList = styled.ul({
  alignItems: 'stretch',
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'center',
  margin: 0,
});

export default PortfolioItemList;
